import { Box } from '@mui/material';
import { useSelector } from 'react-redux';

import { getLocalCategoriesList } from 'entities/Category';
import { getSelectedPropertyCatalogId } from 'entities/Property/model/selectors/PropertySelectors';
import { AddPropertyCatalogCategoryAtList } from 'features/addPropertyCatalogCategory';

import { AddCatalogItemCategory } from './AddCatalogItemCategory';

export const CatalogItemCategoryFormBody = () => {
    const categories = useSelector(getLocalCategoriesList);
    const catalogId = useSelector(getSelectedPropertyCatalogId);

    return (
        <>
            <AddPropertyCatalogCategoryAtList />
            <Box
                data-testid="categories-list"
                display="flex"
                flexDirection="column"
                gap="8px 0"
                mt="14px"
            >
                {categories
                    ? Object.values(categories).map((category) => (
                          <AddCatalogItemCategory
                              key={category.id}
                              id={category.id}
                              color={category.color}
                              catalogId={catalogId}
                              title={category.title}
                              glCode={category.glCode}
                          />
                      ))
                    : null}
            </Box>
        </>
    );
};
